<template>
  <div class="achievements-screen" ref="el">
    <VideoOrImage
      class="achievements-screen__background"
      :style="imageStyle"
      :src="backgroundUri || ACHIEVEMENTS_SCREEN_DEFAULTS.backgroundUri"
    />
    <div class="achievements-screen__content container">
      <ScreenHeader class="achievements-screen__header" data-aos="fade-down">
        <!--        <template #subtitle>-->
        <!--          Our journey to success-->
        <!--        </template>-->
        <template #title> {{ title || ACHIEVEMENTS_SCREEN_DEFAULTS.title }} </template>
        <template #text> {{ subtitle || ACHIEVEMENTS_SCREEN_DEFAULTS.subtitle }} </template>
      </ScreenHeader>
      <div class="achievements-screen__stats" data-aos="fade-up">
        <StatsCounter
          class="achievements-screen__stats-counter"
          v-for="(stat, i) in stats"
          :key="stat.title"
          :title="stat.title"
          :value="stat.value"
          :digits="stat.formatDigits"
          title-class="achievements-screen__stat-title"
          value-class="achievements-screen__stat-value"
          data-aos="fade-up"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  const ACHIEVEMENTS_SCREEN_DEFAULTS = {
    title: "Achievements in Numbers",
    subtitle: "This is just the beginning.",
    backgroundUri: "/screen-bg-1.webp",
  }

  const props = defineProps<{
    backgroundUri?: string;
    title?: string;
    subtitle?: string;
    stats: {
      title: string;
      value: number;
      formatDigits?: number;
    }[];
  }>();

  const imageStyle = computed(() => {
    return {
      transform: `translate(${roll.value * 10}px, ${tilt.value * 10}px)`,
    };
  });

  const el = ref<HTMLDivElement | null>(null);
  const { tilt, roll, source } = useParallax(el);
</script>

<style lang="scss">
  .achievements-screen {
    background-color: #182656;
    background-size: cover;
    background-position: center;

    position: relative;

    padding: 128px 0;
    border-radius: 32px;
    overflow: hidden;

    &__background {
      position: absolute;
      left: -5%;
      top: -5%;
      width: 110%;
      height: 110%;

      opacity: 0.35;
    }

    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 64px;

      @media (max-width: $md) {
        gap: 32px;
      }
    }

    &__header {
      max-width: 512px;

      * {
        color: white;
      }
    }

    &__stats {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      gap: 64px;

      width: 100%;

      @media (max-width: $sm) {
        flex-direction: column;
      }
    }

    &__stats-counter {
      flex: 1 0 0;
    }

    &__stat-title {
      font-size: 16px;
    }

    &__stat-value {
      font-size: 80px;
      @media (max-width: $md) {
        font-size: 56px;
      }
    }
  }
</style>
